import React from 'react'
import clsx from "clsx"
import UserSelect from "../../Selects/UserSelect";
import ServiceLogBuilderErrors from "../ServiceLogBuilderErrors";

export default class ServiceLogBuilderAssignedTo extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "assigned_to",
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="assigned_to">
        {this.props.errors ? this.renderErrors(this.props.errors) : null}
        <div className="row">
          <div className="col-sm-4 form-group">
            <label>{`${I18n.t('assigned_to')}*`}</label>
            <br />
            <div>
              <UserSelect onChange={this.props.onChangeAssignedTo} user={this.props.service_log.assigned_to}  hasError={this.renderFieldClasses('assigned_to_id', true)} />
            </div>
            {this.renderFieldErrors('assigned_to_id')}
          </div>
        </div>    
      </div>
    )
  }

  renderErrors() {
    var errors = ServiceLogBuilderErrors.assigned_to(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, noFormControl) {
    if(noFormControl == true) {
      var classname = ''
    } else {
      var classname = 'form-control'
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    } else {
      classname = classname + " no error"
    }
    return classname
  }
}